import { useAPIs } from "@src/contexts/APIContext";
import { OidcConfigDTO } from "@src/apis/ModularClient";

/**
 * `getOidcConfig`: Returns a function for getting the OidcConfig
 * @param {string} authProvider - Which provider you want to use. It can be "Local", "Microsoft" or "Google"
 */
//Temp code to avoid react errors
export const getOidcConfig = (authProvider: string) => {
  return (): Promise<OidcConfigDTO> => {
    return Promise.resolve({
      authority: "",
      clientId: "",
      clientSecret: "",
      scopes: [],
    });
  };
  // const { claimClient } = useAPIs();
  // return (): Promise<OidcConfigDTO> => {
  //   return Promise.resolve(
  //     claimClient
  //       .getOIDCConfig()
  //       // new AuthClient()
  //       //   .getOidcConfigs(authProvider)
  //       .then((res) => {
  //         //Temp
  //         const result = res[0];
  //         const authority: string = result.authority ?? "";
  //         const clientId: string = result.clientId ?? "";
  //         const clientSecret: string | undefined = result.clientSecret;
  //         const scopes: string[] = result.scopes ?? [];
  //
  //         return {
  //           authority,
  //           clientId,
  //           clientSecret,
  //           scopes,
  //         };
  //       }),
  //   );
  // };
};

export const getMicrosoftOidcConfig = getOidcConfig("Microsoft");

export const getGoogleOidcConfig = getOidcConfig("Google");
